import { useState, useEffect } from "react";
import "./Admin.css";
import Marquee from "react-fast-marquee";
import { FaRegUserCircle } from "react-icons/fa";
import Menu from "../components/Menu";
import Leaveform from "../components/Leaveform";
import Employee from "./Employee";

const Admin = () => {
  const [user, setuser] = useState([]);
  const [att, setatt] = useState([]);
  const [employee, setEmployee] = useState({
    assign: "",
    task: "",
    category: "",
  });

  const [activeStatus, setActiveStatus] = useState("Assigned");

  const [currentTime, setCurrentTime] = useState(new Date());

  const [allTasks, setAllTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [filteredPendingTasks, setFilteredPendingTasks] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedDate = currentTime.toLocaleDateString();
  const formattedTime = currentTime.toLocaleTimeString();

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handleAssignTask = (e) => {
    e.preventDefault();

    if (!employee?.assign || !employee?.task || !employee?.category) {
      alert("Please fill All fields.");
      return;
    } else {
      setIsSubmitting(true);
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/taskassign.php`;
      const formData = new FormData();

      formData.append("category", employee?.category);
      formData.append("task", employee.task);
      formData.append("user_id", employee.assign);
      formData.append("assignby_id", userDetails.id);

      fetch(apiUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          gettodaytask();
          alert(data.message || "Task assigned.");
          setEmployee({
            assign: "",
            task: "",
            category: "",
          });
        })
        .catch((error) => {
          console.error("Error assigning task:", error);
          alert("Something went wrong. Please try again.");
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const fetchuser = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getuser.php`;
    const formData = new FormData();
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Records fetched successfully") {
        setuser(data.data);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  const gettodaytask = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/gettask.php`;
    const formData = new FormData();
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.message === "Records fetched successfully") {
        setAllTasks(data.data);

        const assignedTasks = data.data.filter(
          (task) => task.status === "Assigned"
        );
        setFilteredTasks(assignedTasks);
        setActiveStatus("Assigned");
      }
    } catch (error) {
      console.log("Error fetching tasks:", error);
    }
  };

  const getpendingtask = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/pending_task.php`;
    const formData = new FormData();
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.message === "Records fetched successfully") {
        setFilteredPendingTasks(data.data);
      }
    } catch (error) {
      console.log("Error fetching tasks:", error);
    }
  };

  const handleStatusChange = (status) => {
    setActiveStatus(status);
    const filtered = allTasks.filter((task) => task.status === status);
    setFilteredTasks(filtered);
  };

  const getatt = () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/attendance.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails.id);

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setatt(data.data);
      })
      .catch((error) => {
        console.error("Error assigning task:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    if (userDetails?.role === "admin") {
      fetchuser();
      gettodaytask();
      getpendingtask();
    } else {
      getatt();
    }
  }, []);

  return (
    <div>
      <h1 className="head1">
        {userDetails?.role === "admin"
          ? "Admin Portal"
          : userDetails?.role === "manager"
          ? "Manager Portal"
          : userDetails?.role === "executive"
          ? "Executive Portal"
          : userDetails?.role === "employee"
          ? "Employee Portal"
          : null}
      </h1>

      <div className="center">
        <div className="datetime-container">
          <p className="date">📅 {formattedDate}</p>
          <p className="time">⏰ {formattedTime}</p>
        </div>
        <div className="welcome_tag">
          <span>
            <div className="marquee-container">
              <Marquee
                speed={40}
                direction="right"
                pauseOnHover
                gradient={false}
              >
                {userDetails.empname}
              </Marquee>
            </div>
          </span>
          <div className="profile_icon">
            <FaRegUserCircle />
          </div>
        </div>

        {userDetails?.role !== "employee" && (
          <div>
            <Menu users={user} />
          </div>
        )}

        {userDetails?.role === "employee" && (
          <div>
            {att.length > 0 ? (
              <>
                <h4>No. of Present: {att[0].present_days}</h4>
                <h4>No. of Leave: {att[0].absent_days}</h4>
              </>
            ) : (
              <h4>Loading attendance...</h4>
            )}
          </div>
        )}
      </div>

      {userDetails?.role !== "employee" && (
        <div className="outerad">
          <div className="admin-container">
            <h1 className="head1">Task Assignment</h1>
            {/* Form to assign task */}
            <form
              onSubmit={handleAssignTask}
              className={`task-form ${isSubmitting ? "blurred" : ""}`}
            >
              <div className="form-group">
                <label className="lata">Select Task Category:</label>
                <select
                  id="employee"
                  value={employee?.category}
                  onChange={(e) =>
                    setEmployee((pv) => ({ ...pv, category: e.target.value }))
                  }
                >
                  <option value="" disabled>
                    Select Task Category
                  </option>
                  <option value="task">Task</option>
                  <option value="new learning">New Learning</option>
                </select>
              </div>

              <div className="form-group">
                <label className="lata">Assign to:</label>
                <select
                  id="employee"
                  value={employee?.assign}
                  onChange={(e) =>
                    setEmployee((pv) => ({ ...pv, assign: e.target.value }))
                  }
                >
                  <option value="" disabled>
                    Select Employee
                  </option>

                  {userDetails?.role === "admin" ? (
                    <>
                      {user
                        .filter(
                          (userDetails) =>
                            !["admin", "executive"].includes(userDetails?.role)
                        )
                        .map((emp, index) => (
                          <option key={index} value={emp?.id}>
                            {emp?.emp_name}
                          </option>
                        ))}
                    </>
                  ) : (
                    <>
                      {user
                        .filter(
                          (userDetails) =>
                            !["admin", "executive", "manager"].includes(
                              userDetails?.role
                            )
                        )
                        .map((emp, index) => (
                          <option key={index} value={emp?.id}>
                            {emp?.emp_name}
                          </option>
                        ))}
                    </>
                  )}
                </select>
              </div>

              <div className="form-group">
                <label className="lata">Task:</label>
                <textarea
                  id="task"
                  value={employee?.task}
                  onChange={(e) =>
                    setEmployee((pv) => ({ ...pv, task: e.target.value }))
                  }
                  placeholder="Enter Task..."
                  rows="3"
                  cols="50"
                />
              </div>

              <button type="submit" className="assign-btn">
                Assign Task
              </button>
            </form>
          </div>

          <div className="tasks-container">
            <div className="task-filter-btns">
              <button
                onClick={() => handleStatusChange("Assigned")}
                className={activeStatus === "Assigned" ? "active" : ""}
              >
                Assigned Tasks
              </button>
              <button
                onClick={() => handleStatusChange("Pending")}
                className={activeStatus === "Pending" ? "active" : ""}
              >
                Pending Tasks
              </button>
            </div>

            {/* Displaying the filtered tasks */}
            {activeStatus === "Assigned" ? (
              <div className="assigned-tasks">
                <h2>
                  {activeStatus.charAt(0).toUpperCase() + activeStatus.slice(1)}{" "}
                  Tasks:
                </h2>

                {filteredTasks.length === 0 ? (
                  <p>No tasks available.</p>
                ) : (
                  <div className="task-table-wrapper">
                    <table className="task-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Employee</th>
                          <th>Category</th>
                          <th>Task</th>
                          <th>Assigned BY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredTasks.map((task, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{task.emp_name}</td>
                            <td>{task?.category}</td>
                            <td>{task.task}</td>
                            <td style={{ width: "200px" }}>
                              <strong>{task.assign_name} - </strong>
                              {task.assign_time}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ) : (
              <div className="assigned-tasks">
                <h2>
                  {activeStatus.charAt(0).toUpperCase() + activeStatus.slice(1)}{" "}
                  Tasks:
                </h2>
                {filteredPendingTasks.length === 0 ? (
                  <p>No tasks available.</p>
                ) : (
                  <div className="task-table-wrapper">
                    <table className="task-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Employee</th>
                          <th>Category</th>
                          <th>Task</th>
                          <th>Assigned BY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredPendingTasks.map((task, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{task.emp_name}</td>
                            <td>{task?.category}</td>
                            <td>{task.task}</td>
                            <td style={{ width: "200px" }}>
                              <strong>{task.assign_name} - </strong>
                              {task.assign_time}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* Task Filter and Tasks List */}
        </div>
      )}

      {userDetails?.role === "employee" && <Employee />}
      <Leaveform />
    </div>
  );
};

export default Admin;
